import { render, staticRenderFns } from "./AccountOwner.vue?vue&type=template&id=675310d0&scoped=true"
import script from "./AccountOwner.vue?vue&type=script&lang=js"
export * from "./AccountOwner.vue?vue&type=script&lang=js"
import style0 from "./AccountOwner.vue?vue&type=style&index=0&id=675310d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675310d0",
  null
  
)

export default component.exports